import { css } from 'emotion';
import React from 'react';

import { Card } from '../../../../../../../components/Card';
import { Color, Dimension, FontSize } from '../../../../../../../constants/Style';
import { useMedia } from '../../../../../../../hooks/useMedia';
import { ExternalDivisionLink } from '../../../constants/ExternalDivisions';
import { departmentCardLayout } from '../DepartmentCard';
import { DepartmentCardHeader } from '../DepartmentCard/DepartmentCardHeader';

export type Props = {
  link: ExternalDivisionLink;
};

/**
 * 診療科カードと同じ体裁で外部サイトへ遷移させるカード。
 * 予約フローから離脱させないよう別タブで開く。
 */
export const ExternalDivisionCard = ({ link }: Props) => {
  const sp = useMedia([{ query: `(max-width: ${Dimension.ContentWidthMax}px)`, value: true }], false);
  return (
    <a className={anchor} href={link.url} target="_blank" rel="noopener noreferrer">
      <Card shadowType="floating" smallPadding={sp}>
        <div className={departmentCardLayout}>
          <DepartmentCardHeader icon={link.icon} name={link.name} />
          {!sp && link.description && <footer className={description}>{link.description}</footer>}
        </div>
      </Card>
    </a>
  );
};

const anchor = css`
  color: inherit;
  text-decoration: none;
`;

const description = css`
  font-size: ${FontSize.Small};
  color: ${Color.GrayscaleNeutral};
`;
